// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__323gG","calendarButtons":"ClockData_calendarButtons__2AD05"};